import { Box, Button, Chip, Divider, FormLabel, Grid } from '@mui/material';

import BoyIcon from '@mui/icons-material/Boy';
import GirlIcon from '@mui/icons-material/Girl';
import CakeIcon from '@mui/icons-material/Cake';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallIcon from '@mui/icons-material/Call';
import AadharIcon from "../../assets/aadhaar.svg";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';


import useDisplayDate from '../../hooks/Date/useDisplayDate';
import PrimaryTable from '../../components/Table/PrimaryTable';
import { useGetLeadsMutation } from '../../features/leads/leadApi';
import useLeadColumns from '../../components/TableHeader/LeadColumns';
import { setLeads, setLoading } from '../../features/leads/leadSlice';
import { useState } from 'react';
import AppCollLoan from './AppCollLoan';
import { useDispatch, useSelector } from 'react-redux';

const LeadInformation = ({custdata}) =>{
    const {formatDate } = useDisplayDate();
    const dispatch = useDispatch();
    const [leadData,setLeadData] = useState(null);


    const { leads, totalRowCount, isLoading } = useSelector((state) => state.leads);
    

    console.warn(leadData,"leadData");
    const handleCellClick = (rowData) => {
      setLeadData(rowData);

    };

    const [getLeads] = useGetLeadsMutation();

    const columns = useLeadColumns(handleCellClick);


      const fetchData = async ({ pagination, sorting, columnFilters, globalFilter }) => {
        dispatch(setLoading(true));
        try {
          const res = await getLeads({
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize,
            sorting,
            columnFilters,
            globalFilter,
            data: {
              customerID: custdata?.customerID,DB: custdata?.TAG
            },
          }).unwrap();
    
          dispatch(setLeads({ data: res.data, totalRowCount: res.data.totalRowCount })); 
        } catch (error) {
          console.error('Failed to fetch leads', error);
        } finally {
          dispatch(setLoading(false));
        }
      };

   

    return (
             <>
                                <Divider sx={{mb: 1}}>
                                    

                                          <Chip label={custdata?.comp + ' - ' + custdata?.customerID + ' - ' + custdata?.name} 
                                          size="small" 
                                          className={custdata?.gender === "Male" ? "bg-446493 text-white" : "bg-FFC0CB text-white"}
                                          sx={{backgroundColor: custdata?.gender === "Male" ? "primary.main" : "",color: custdata?.gender === "Male" ? "white" : ""}}
                                           onClick={() => {}}

                                          />
                                   
                                          
                                </Divider>



                                

                                {leadData?.leadID && leadData?.customerID ?
                                          <AppCollLoan leadData={leadData} setLeadData={setLeadData}/>
                                   :
                                          <PrimaryTable
                                               columns={columns}
                                               data={leads}
                                               isLoading={isLoading}
                                               totalRowCount={totalRowCount}
                                               fetchData={fetchData}
                                          />

                                }
             
             </>
    )
}

export default LeadInformation